import { Template } from "src/lib/templates";
import { emailTemplate } from "./emailTemplate";

export const recoveryTemplate: Template = {
  name: "Recovery Form",
  template: [emailTemplate],
};
